/* js/outrotext.js */


$(".outrotext__icon").click(function() {
    $('html, body').animate({
        scrollTop: $("#leaflet").offset().top
    }, 2000);
});

$(".cta__btn-right a").click(function() {
  $('html, body').animate({
    scrollTop: $("#leaflet").offset().top
  }, 2000);
});
